import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { MiqBehaviors } from '@shared/behaviors';
import { getLovValueKey } from '@shared/utils/helpers/lov-datakey-factory';

import { BaseInput } from '../base-input';

@Component({
  selector: 'miq-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [{ provide: MiqBehaviors, useExisting: SelectComponent }],
  standalone: false,
})
export class SelectComponent extends BaseInput implements OnInit, OnChanges, OnDestroy {
  @Input() values = [];
  @Input() declare currentValue: string;
  @Input() placeholder = 'shared.select';
  @Input() lookupCategory: string;
  @Input() panelClass: boolean;
  @Input() capitalized = false;
  @Input() showNullOption = true;
  @Input() isWarningDisplayed = false;

  @Output() currentValueChange = new EventEmitter<string>();

  /**
   * Proxy matInput blur event (bubble up matInput blur event)
   */
  @Output() blur = new EventEmitter<FocusEvent>();

  @ViewChild(MatSelect, { static: false }) matSelect: MatSelect;

  dataKey = 'key';

  ngOnInit(): void {
    super.ngOnInit();
    this.dataKey = getLovValueKey(this.column);
    this.showNullOption = this.column?.customConfig?.showNullOption ?? this.showNullOption;
    if (this.column?.showInvalidLookupValue && !!this.currentValue) {
      if (!this.values.find(v => v[this.dataKey] === this.currentValue)) {
        this.values = [...this.values, { [this.dataKey]: this.currentValue, value: this.currentValue, disabled: true }];
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    const { currentValue } = changes;
    if (!!currentValue && !currentValue.firstChange) {
      this.fc.setValue(this.currentValue);
    }
    if (
      changes?.isWarningDisplayed &&
      changes?.isWarningDisplayed?.currentValue &&
      !changes?.isWarningDisplayed?.firstChange
    ) {
      this.isWarningDisplayed = changes.isWarningDisplayed.currentValue;
    }
  }

  public onChange(val) {
    this.currentValue = val;
    this.currentValueChange.emit(this.valueSetter ? this.valueSetter(val) : val);
  }

  public focus() {
    this.matSelect.focus();
  }

  ngOnDestroy() {
    /* label translation purpose added */
    this.matSelect = null;
  }
}
